<template>
  <div class="resend-email-box hide-in-mobile">
    <div class="dovemed-wrapper d-flex justify-content-between w-100">
      <div v-if="showResendEmail && authUser" class="resend-email-box__fail">
        <div :style="{ 'text-align': 'center' }">
          A confirmation email was sent to
          <span :style="{ 'font-weight': 'bold', color: '#ffffff', margin: '0px 5px', display: 'inline-block' }"> {{ authUser.user.email }}. </span>
          <span :style="{ color: '#ffffff', margin: '0px 5px', display: 'inline-block' }">
            Please confirm and refresh the page.
          </span>
        </div>
        <div class="resend-email-box__fail--button font-weight-bold" @click="handleResendEmailConfirmation">RESEND CONFIRMATION</div>
      </div>
      <!-- <div v-if="!showResendEmail"> -->
      <div v-else>
        <a class="dovemed-link d-flex" :href="SSO_BASE_URL" target="_blank" :style="{ color: '#ffffff !important', 'font-size': '12px', padding: '5px 10px' }">
          <div class="mr-1 d-felx align-items-center">
            <font-awesome-icon size="1x" :icon="['far', 'arrow-left']" :style="{ color: '#ffffff !important', 'font-size': '12px' }" />
          </div>
          <div class="d-flex align-items-center" :style="{ color: '#ffffff !important', 'font-size': '12px' }">GO TO DOVEMED</div>
        </a>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
// import { mapState } from "vuex"
// import { RepositoryFactory } from "../../repositories/RepositoryFactory"

// const CircleRepository = RepositoryFactory.get("circle")
// const UserRepository = RepositoryFactory.get("user")

export default {
  name: "ResendBar",
  computed: {
    // ...mapState({ resendMail: state => state.App.resendMail }),
    SSO_BASE_URL: () => process.env.SSO_BASE_URL,
  },
  data: function() {
    return {
      // showContent: false,
      // searchKey: undefined,
      // searchList: [],
      showResendEmail: false,
      isScrollDown: false,
    }
  },
  watch: {
    authUser: {
      handler(v) {
        if (v) {
          if (v.user.hasOwnProperty("verified_account") && v.user.verified_account === false) {
            this.showResendEmail = true
          } else {
            this.showResendEmail = false
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    console.warn("resendBar.vue is mounted")
    if (this.authUser) {
      if (this.authUser.user.hasOwnProperty("verified_account") && this.authUser.user.verified_account === false) {
        this.showResendEmail = true
      }
    }
    if (!this.authUser) {
      this.showResendEmail = false
    }
    window.addEventListener("wheel", this.handleScroll)
  },

  destroyed() {
    window.removeEventListener("wheel", this.handleScroll)
  },

  methods: {
    handleScroll(e) {
      let oldValue = 0
      let newValue = 0
      let head = document.querySelector(".resend-email-box")
      // console.log(document.querySelector("body").style.overflow === "hidden");
      const isModalOpen = document.querySelector("body").style.overflow === "hidden"
      newValue = e.wheelDeltaY
      if (!isModalOpen) {
        if (oldValue < newValue) {
          this.isScrollDown = true
          head && head.classList.remove("sticky_header")
        } else if (oldValue > newValue) {
          this.isScrollDown = false
          head && head.classList.add("sticky_header")
        }
      }
      oldValue = newValue
    },

    handleCloseBox() {
      const payload = { email: this.authUser.user.email, isVisible: false }
      this.$store.commit("App/setMail", payload)
    },

    handleResendEmailConfirmation() {
      if (this.authUser.user.hasOwnProperty("verified_account")) {
        let config = { headers: { DTOKEN: this.authUser.user.token, Cookie: `textsize=3; ${document.cookie}` } }
        axios
          .post(`${process.env.SSO_BASE_URL}/api/v2/accounts/verification/create-new-link/`, { email: this.authUser.user.email }, config)
          .then(res => {
            this.$notification.success({ message: "Success", description: "Mail has been sent." })
            this.handleCloseBox()
          })
          .catch(err => {
            this.$notification.error({ message: "Error", description: "Error while trying to send the mail." })
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.sticky_header {
  display: none !important;
}
.resend-email-box {
  // height: 40px;
  // height: 100px;
  height: fit-content;

  transition: height 1s;
  background: #062b54;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;

  &__fail {
    display: flex;
    align-items: center;
    font-size: 12px;
    justify-content: center;
    width: 100%;
    @media screen and (max-width: 900px) {
      flex-direction: column;
    }
    &--button {
      margin-left: 25px;
      font-size: 10px;
      background: hsla(0, 0%, 100%, 0.172);
      padding: 5px;
      border-radius: 5px;
      color: #ffffff;
      cursor: pointer;
      @media screen and (max-width: 900px) {
        margin-left: 0px;
        margin-bottom: 5px;
      }
    }
  }

  // &:hover {
  //   height: 200px;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/App/resendBar.vue